import HtmlContent from '@/components/elements/HtmlContent';
import { useUIResource, useUIResourcePool } from '@/ducks/common/resources';
import { selectCelebrationsIsFlowActive } from '@/ducks/programs/celebrations/selectors';
import { selectIsSailingDataLoaded } from '@/ducks/voyageInfo/sailing/selectors';
import withSkeleton from '@/hocs/withSkeleton';
import { useAppSelector } from '@/store';

import HeadingSkeleton from './HeadingSkeleton';

import './Heading.scss';

const Heading = ({ onExitClick, shipName }) => {
  const isCelebrationFlowActive = useAppSelector(selectCelebrationsIsFlowActive);

  const { celebrationExitTitle, celebrationSubTitle, celebrationTitle } = useUIResourcePool(UI_RESOURCE_POOL);
  const shipNameTitle = useUIResource(CMS_TEMPLATE_IDS.defaultTitle, { Ship: shipName });

  const title = isCelebrationFlowActive ? celebrationTitle : shipNameTitle;
  const subTitle = isCelebrationFlowActive ? celebrationSubTitle : '';
  const exitTitle = celebrationExitTitle;

  return (
    <div className="heading">
      <HtmlContent className="title" content={title} node="h1" />
      {subTitle && (
        <p className="subTitleContainer">
          <span className="subTitle">{subTitle}</span>
          &nbsp;
          {exitTitle && (
            <span
              aria-label="Close the celebration flow"
              className="subTitle action"
              onClick={onExitClick}
              onKeyDown={onExitClick}
              role="button"
              tabIndex={0}
            >
              {exitTitle}
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export const UI_RESOURCE_POOL = {
  celebrationExitTitle: 'Celebration.Exit.CTA',
  celebrationSubTitle: 'Celebration.Explore.Voyage.Title',
  celebrationTitle: 'Celebration.Restored.Title',
};

export const CMS_TEMPLATE_IDS = {
  defaultTitle: 'Precheckout.heading',
};

export default withSkeleton(Heading, {
  selector: (state, { searchParams }) => selectIsSailingDataLoaded(state, searchParams),
  skeleton: HeadingSkeleton,
});
